exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.rightBtn[data-v-60afbf80] {\n  width: 0.3rem;\n  position: absolute;\n  right: 0.75rem;\n  bottom: 0.95rem;\n}\n.originalPrice[data-v-60afbf80] {\n  position: absolute;\n  left: 5rem;\n  bottom: 0.75rem;\n  color: #999;\n  font-size: 0.6rem;\n}", ""]);

// exports
